import "./NewMechanicalBulls.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Catalog from "./sections/Catalog";
import ElectricBulls from "./sections/ElectricBulls";
import Inclusions from "./sections/Inclusions";
import Machinery from "./sections/Machinery";
import WhyBuyNew from "./sections/WhyBuyNew";
import Controller from "./sections/Controller";
import Powerspace from "./sections/Powerspace";
import BullPricing from "./sections/BullPricing";
import Comparison from "./sections/Comparison";
import Parts from "./sections/Parts";
import ShippingNewMechanicalBulls from "./sections/ShippingNewMechanicalBulls";
import BullFaq from "./sections/BullFaq";
import FindBull from "./sections/FindBull";
import Footer from "@/reusable_sections/Footer";
import Electricbullsforsale from "./sections/Electricbullsforsale";
export default function NewMechanicalBullsPage() {
  return <div>
      <Header />
      <Hero />
      <Catalog />
      <ElectricBulls />
      <Inclusions />
      <Electricbullsforsale />
      <Machinery />
      <WhyBuyNew />
      <Controller />
      <Powerspace />
      <BullPricing />
      <Comparison />
      <Parts />
      <ShippingNewMechanicalBulls />
      <BullFaq />
      <FindBull />
      <Footer />
    </div>;
}